import { all } from "redux-saga/effects";
import { dotDangKyNganh2Saga } from "./dotDangKyNganh2Saga";
import { danhSachDangKyNganh2Saga } from "./danhSachDangKyNganh2Saga";
import { danhSachNganh2Saga } from "./danhSachNganh2Saga";

export function* quanLyNganh2SagaWrapper() {
    yield all([
        dotDangKyNganh2Saga(),
        danhSachDangKyNganh2Saga(),
        danhSachNganh2Saga()
    ]);
}